import { render } from "./properties.vue?vue&type=template&id=53cb7c0e&scoped=true&ts=true"
import script from "./properties.vue?vue&type=script&lang=ts"
export * from "./properties.vue?vue&type=script&lang=ts"

import "./properties.vue?vue&type=style&index=0&id=53cb7c0e&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cb7c0e"]])

export default __exports__